var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlipHori(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 15,
    viewBox: "0 0 31 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95049 5.70374L6.92867 2.76203C6.92174 1.82676 8.08802 1.3947 8.6921 2.10875L12.5636 6.68505C12.8895 7.07038 12.8773 7.63823 12.535 8.00913L8.68534 12.1803C8.06793 12.8493 6.95047 12.4125 6.95048 11.5021L6.95049 5.70374Z",
    stroke: "#525866",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1952 12.4536L15.3696 1.60657",
    stroke: "#525866",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6144 5.70374L23.6363 2.76203C23.6432 1.82676 22.4769 1.3947 21.8728 2.10875L18.0014 6.68505C17.6754 7.07038 17.6877 7.63823 18.03 8.00913L21.8796 12.1803C22.497 12.8493 23.6145 12.4125 23.6145 11.5021L23.6144 5.70374Z",
    stroke: "#525866",
    strokeWidth: 1.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipHori);
export default __webpack_public_path__ + "static/media/flip-hori.e0366a997393b5f03bf4621909bb6fa5.svg";
export { ForwardRef as ReactComponent };